import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import AmenityPresenterTabContent from "./AmenityPresenterTabContent";

class AmenityPresenter extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      active_tab: 'general',
      errors: this.props.errors || {},
      amenity: this.props.amenity || {},
      room_types: this.props.room_types && this.props.room_types.length ? this.props.room_types : [],
      amenity_revision_history_path: this.props.amenity_revision_history_path || '',
      date_format: this.props.date_format || null,
      time_format: this.props.time_format || null,
      historical_view: this.props.historical_view || null,
      ...this.props
    }

    this.setActiveTab = this.setActiveTab.bind(this)
    this.onChangeRevertVersion = this.onChangeRevertVersion.bind(this)
  }

  componentDidMount() {
    var self = this
    $(window).on("amenitySaved", function () {
      $.ajax({
        type: 'POST',
        url: `/admin/amenities/${self.state.amenity.id}/data`,
      }).done((data) => {
        self.setState({...data});
      })
    });
  }

  render() {
    var self = this
    var buttons = [
      {
        name: I18n.t('ok'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      }
    ]

    return (
      <div className="RoomTypeBuilder">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          {/* <AmenityPresenterTabs
            active_tab={this.state.active_tab}
            setActiveTab={this.setActiveTab}
            historical_version={this.props.historical_version}
          /> */}
          <AmenityPresenterTabContent
            active_tab={this.state.active_tab}
            amenity={this.state.amenity}
            room_types={this.state.room_types}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            amenity_revision_history_path={this.state.amenity_revision_history_path}
          />
        </div>
      </div>
    )
  }

  tabs() {
    if (this.props.historical_view == true) {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.setActiveTab,
          },
          // {
          //   tabName: I18n.t('room_types'),
          //   targetName: 'room-types',
          //   classes: this.state.active_tab === 'room-types' ? 'active' : null,
          //   changeHandler: this.setActiveTab,
          // },
        ]
      );
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.setActiveTab,
          },
          {
            tabName: I18n.t('room_types'),
            targetName: 'room-types',
            classes: this.state.active_tab === 'room-types' ? 'active' : null,
            changeHandler: this.setActiveTab,
          },
          {
            tabName: I18n.t('history'),
            targetName: 'history',
            classes: this.state.active_tab === 'history' ? 'active' : null,
            changeHandler: this.setActiveTab,
          },
        ]
      );
    }
  };

  renderFieldErrors(object, field) {
    if (object && object.errors && object.errors[field]) {
      var idx = 0;
      var errors = object.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  setActiveTab(name) {
    this.setState({active_tab: name})
  }

  onChangeRoomType(room_type_ids) {
    var amenity = {...this.state.amenity}
    amenity.room_type_ids = room_type_ids
    this.setState({amenity: amenity})
  }

  onChangeField(event) {
    var amenity = {...this.state.amenity}
    amenity[event.target.name] = event.target.value
    this.setState({
      amenity: amenity
    })
  }

  onChangeRevertVersion() {
    $.ajax({
      type: 'POST',
      url: `/admin/amenities/${this.props.amenity.id}/version/${this.props.version.id}/revert`,
    }).done((data) => {
      window.parent.$(window.parent).trigger('amenitySaved');
      this.setState({loading: false});
      if (parent && parent.refresh_data) {
        parent.refresh_data(I18n.t('record_reverted_successfully'));
      }
      if (parent && parent.hide_modal) {
        parent.hide_modal();
      }
    })
  }
}

export default AmenityPresenter
